// JsFromRoutes CacheKey d6ef8e7ceb82afbb780737d291af98e7
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  reorder: /* #__PURE__ */ definePathHelper('patch', '/:account_id/topics/reorder'),
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/topics'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/topics/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/topics/:id'),
}
